<template>
    <div class="toolbar">
        <!-- 未授权 -->
        <div class="auth-state" v-if="toolbarType == 'unauth'">
            <!-- facebook授权登录 -->
            <div class="btn-auth fb-auth" @click="handleFbAuth"></div>
            <!-- vk授权登录 -->
            <div class="btn-auth vk-auth" @click="handleVkAuth"></div>
        </div>
        <!-- 选择领养像素龙 -->
        <div class="select-pets-state" v-if="toolbarType == 'selectPet'">
            <!-- 确认领养 -->
            <div class="select-btn select-confirm" @click="adoptDragon">
                {{ $t('base.adoptBattle') }}
            </div>
            <!-- 换一只领养 -->
            <div class="select-btn select-ex" @click="exchangeDragon">
                {{ $t('base.changeDragon') }}
            </div>
        </div>
        <!-- 主状态  -->
        <div
            class="main-state"
            v-if="toolbarType == 'main1' || toolbarType == 'main2'"
        >
            <!-- 第一次进入状态 -->
            <div class="first-main-state" v-if="toolbarType == 'main1'">
                <!-- 截屏按钮 -->
                <div class="main-btn btn-camera" @click="goPage('share')"></div>
                <!-- 主页按钮 -->
                <div class="main-btn btn-home" @click="goPage('home')"></div>
                <!-- 分享按钮 -->
                <div class="main-btn btn-share" @click="handleShare"></div>
            </div>
            <!-- 第二次进入状态 -->
            <div class="second-main-state" v-else>
                <!-- 好友按钮 -->
                <div
                    class="main-btn btn-friend"
                    :class="{ d: friendShow }"
                    @click="showPopupFri"
                ></div>
                <!-- 战力页按钮 -->
                <div
                    class="main-btn btn-battle"
                    :class="{ d: userShow }"
                    @click="goPage('user')"
                ></div>
                <!-- 主页按钮 -->
                <div
                    class="main-btn btn-home"
                    :class="{ d: homeShow }"
                    @click="goPage('home')"
                ></div>
                <!-- 分享按钮 -->
                <div class="main-btn btn-share" @click="handleShare"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import { CONFIG } from '@/config/index';
import { urlParser } from '@/utils';
import { Bus } from '@/utils/eventBus.js';
export default {
    name: 'toolbar',
    computed: {
        toolbarType() {
            return this.$store.state.toolbarType;
        },
        friendShow() {
            return this.$store.state.popup.friend;
        },
        homeShow() {
            return this.$store.state.game.view == 'home';
        },
        userShow() {
            return this.$store.state.game.view == 'user';
        }
    },
    methods: {
        ...mapMutations([
            'SHOW_POPUP',
            'HIDE_POPUP',
            'PLAY_SOUND',
            'STOP_SOUND'
        ]),
        ...mapActions(['getAuthLocation', 'changeDragon', 'confirmDragon']),

        // fb授权登录
        handleFbAuth() {
            this.PLAY_SOUND('button');
            const myurl = urlParser(location.href);
            myurl.data('channel', 'facebook');
            this.$LOG.send_click_login_fb();
            this.getAuthLocation({
                channel: 'facebook',
                redirect_uri: CONFIG.domain + '/h5/authCallback.html',
                state: myurl.url()
            });
        },
        // vk授权dengl
        handleVkAuth() {
            this.PLAY_SOUND('button');
            const myurl = urlParser(location.href);
            myurl.data('channel', 'vk');
            this.$LOG.send_click_login_vk();
            this.getAuthLocation({
                channel: 'vk',
                redirect_uri: CONFIG.domain + '/h5/authCallback.html',
                state: encodeURIComponent(myurl.url())
            });
        },
        // 弹出分享弹层
        handleShare() {
            this.PLAY_SOUND('button');
            this.SHOW_POPUP('share');
        },
        showPopupFri() {
            this.PLAY_SOUND('button');
            if (this.friendShow) {
                return;
            }
            Bus.$emit('_goPage', 'empty', () => {
                this.SHOW_POPUP('friend');
            });
        },
        // 换一只领养
        exchangeDragon() {
            this.PLAY_SOUND('button');
            // this.changeDragon();
            Bus.$emit('_changeDragon');
        },
        // 确认领养
        adoptDragon() {
            this.PLAY_SOUND('button');
            // this.confirmDragon();
            Bus.$emit('_confirmDragon');
            this.$LOG.send_click_adopt_dragon();
        },
        // 前往战力页
        goPage(page) {
            this.PLAY_SOUND('button');
            this.HIDE_POPUP('friend');
            Bus.$emit('_goPage', page);
        }
    }
};
</script>

<style lang="less" scoped>
.toolbar {
    width: 100%;
    display: flex;

    .auth-state {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;

        .btn-auth {
            width: 116px;
            height: 122px;

            &:active {
                transform: scale(0.94);
            }

            &.fb-auth {
                background: url(~@/assets/img/btn_fb.png) center/100% 100%
                    no-repeat;
            }

            &.vk-auth {
                background: url(~@/assets/img/btn_vk.png) center/100% 100%
                    no-repeat;
                margin-left: 58px;
            }
        }
    }

    .select-pets-state {
        display: flex;
        // justify-content: center;
        align-items: center;
        width: 100%;

        .select-btn {
            width: 269px;
            height: 93px;
            font-size: 28px;
            line-height: 93px;
            // padding-top: 26px;
            box-sizing: border-box;
            text-align: center;

            &:active {
                transform: scale(0.94);
            }

            &.select-ex {
                background: url(~@/assets/img/btn_green.png) center/100% 100%
                    no-repeat;
                margin-left: 32px;
                color: #fff;
                animation: clickAni 0.25s ease-in-out infinite alternate;

                @keyframes clickAni {
                    from {
                        transform: scale(1);
                    }
                    to {
                        transform: scale(0.9);
                    }
                }
            }

            &.select-confirm {
                background: url(~@/assets/img/btn_yellow.png) center/100% 100%
                    no-repeat;
                margin-left: 28px;
                color: #ac842d;
            }
        }
    }

    .main-state {
        width: 100%;

        .first-main-state {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
        }

        .second-main-state {
            display: flex;
            justify-content: center;
            align-items: center;
            padding-right: 72px;
            box-sizing: border-box;
            width: 100%;

            .main-btn {
                margin-right: 32px;
            }
        }

        .main-btn {
            width: 117px;
            height: 118px;
            margin-right: 48px;

            &:last-child {
                margin-right: 0;
            }

            &:active {
                transform: scale(0.94);
            }

            &.d {
                &:active {
                    transform: scale(1);
                }
            }

            &.btn-camera {
                background: url(~@/assets/img/btn_camera.png) top center/100%
                    100% no-repeat;

                &.d {
                    background: url(~@/assets/img/btn_camera_d.png) top
                        center/100% 100% no-repeat;
                }
            }

            &.btn-home {
                background: url(~@/assets/img/btn_home.png) top center/100% 100%
                    no-repeat;

                &.d {
                    background: url(~@/assets/img/btn_home_d.png) top
                        center/100% 100% no-repeat;
                }
            }

            &.btn-friend {
                background: url(~@/assets/img/btn_fri.png) top center/100% 100%
                    no-repeat;

                &.d {
                    background: url(~@/assets/img/btn_fri_d.png) top center/100%
                        100% no-repeat;
                }
            }

            &.btn-battle {
                background: url(~@/assets/img/btn_battle.png) top center/100%
                    100% no-repeat;

                &.d {
                    background: url(~@/assets/img/btn_battle_d.png) top
                        center/100% 100% no-repeat;
                }
            }

            &.btn-share {
                background: url(~@/assets/img/btn_share.png) top center/100%
                    100% no-repeat;
            }
        }
    }
}
</style>
